/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import useAuthStore from '../store/useAuthStore';
import { UserRole } from '../types/auth.types';

export const useAuth = () => {
  const { initAuth, isAuthenticated, roleList, isLoading } = useAuthStore();

  useEffect(() => {
    initAuth();
  }, []);

  const checkAccess = (allowedRoles: UserRole[]) => {
    if (!isAuthenticated || !roleList) return false;

    // Convertir role a array si es string
    const userRoles: UserRole[] = Array.isArray(roleList)
      ? roleList
      : typeof roleList === 'string'
        ? roleList.split(',').map(r => r.trim() as UserRole)
        : [roleList];

    return userRoles.some(userRole => allowedRoles.includes(userRole));
  };

  return {
    isAuthenticated,
    roleList,
    isLoading,
    checkAccess
  };
};